/*
 * A vote row with the option's audio beside the label (never inside it). The label grows to take the free space,
 * so the audio control sits at the end of the same line; only an opened player wraps onto a line of its own.
 */
.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--tuna-spacing-1);
}

/* The vote views give their labels `width: 100%`, which would leave no room on the line for the audio control. */
.row > label {
  flex: 1 1 0;
  min-width: 0;
  width: auto;
}

/* The player window: its own line under the option, full width. */
.player {
  flex-basis: 100%;
  margin-top: var(--tuna-spacing-1);
  margin-bottom: var(--tuna-spacing-1);
}
